import React, { useContext } from 'react'
import { TemplateContext } from '../../context/template'
import { isEmpty } from 'lodash'
import { isMobile } from 'react-device-detect'
import CustomPlayer from '../player/customPlayer'
import NewCustomizedPlayer from './newCustomizedPlayer'
import { useNavigate } from 'react-router'
import ExternalLinkPlayer from './externalLinkPlayer'

const PlayerHome = (props) => {
  const navigate = useNavigate()
  const { playerTemplateData, playerTemplateLoaded } = useContext(TemplateContext)
  const {
    contentInfo,
    contentWatchUrl,
    resumeTime,
    handlePlayingSequence,
    disableHeader,
    loop,
    controlBar,
    adCampaignData,
    onVideoComplete,
    handleNext = null,
    handlePrev = null,
    stillWatchingAllowed = false,
  } = props

  const isYoutubePlayer = !isEmpty(contentInfo?.youtube_data)

  const handlePrevDefault = () => {
    if (window.history?.length && window.history.length > 1) {
      navigate(-1)
    }
  }

  return (
    <div className="w-full h-full">
      {isYoutubePlayer ? (
        <ExternalLinkPlayer
          youtubeData={contentInfo?.youtube_data}
          contentInfo={contentInfo}
          resumeTime={resumeTime}
          handlePlayingSequence={handlePlayingSequence}
          adCampaignData={adCampaignData}
          onVideoComplete={onVideoComplete}
          playerData={playerTemplateData?.data}
          handleNext={handleNext}
          handlePrev={handlePrev ? handlePrev : handlePrevDefault}
          stillWatchingAllowed={stillWatchingAllowed}
          disableHeader={disableHeader}
          loop={loop}
          controlBar={controlBar}
        />
      ) : playerTemplateLoaded ? (
        !`${contentInfo.video_type}`.includes('LIVE') &&
        !isMobile &&
        !isEmpty(playerTemplateData?.data) ? (
          <NewCustomizedPlayer
            contentInfo={contentInfo}
            contentWatchUrl={contentWatchUrl}
            resumeTime={resumeTime}
            handlePlayingSequence={handlePlayingSequence}
            adCampaignData={adCampaignData}
            onVideoComplete={onVideoComplete}
            playerData={playerTemplateData?.data}
            handleNext={handleNext}
            handlePrev={handlePrev ? handlePrev : handlePrevDefault}
            stillWatchingAllowed={stillWatchingAllowed}
            controlBar={controlBar}
          />
        ) : (
          <CustomPlayer
            playerData={isEmpty(playerTemplateData?.data) ? {} : playerTemplateData?.data}
            contentInfo={contentInfo}
            contentWatchUrl={
              contentInfo.video_type === 'LIVE' ? contentInfo.stream.link : contentWatchUrl
            }
            resumeTime={resumeTime}
            handlePlayingSequence={handlePlayingSequence}
            disableHeader={disableHeader}
            loop={loop}
            controlBar={controlBar}
            adCampaignData={adCampaignData}
            onVideoComplete={onVideoComplete}
            handleNext={handleNext}
            handlePrev={handlePrev ? handlePrev : handlePrevDefault}
            stillWatchingAllowed={stillWatchingAllowed}
          />
        )
      ) : null}
    </div>
  )
}

export default PlayerHome
